// extracted by mini-css-extract-plugin
export default {"combinedShieldRoot":"combinedShieldRoot___Ror8j","chef":"chef___T2865","s":"s___AjUwz","m":"m___rZta1","l":"l___n6pSs","combinedShieldImg":"combinedShieldImg___cjTUT"};